import { AppRouter } from '@plura/server/trpc';
import { createTRPCReact } from '@trpc/react-query'

export const trpc = createTRPCReact<AppRouter>({});